import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { Link, useNavigate, useParams } from "react-router-dom";

//import images
import slack from "../../../assets/images/brands/slack.png";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import NewsService from "../../../services/KangarooServices/NewsService";
import { formatDateTime } from "../../../Components/Common/FormatDate";
import { imageBaseApi } from "../../../utilis/imageHelper";
import { Edit3 } from "lucide-react";

const BlogDetail = () => {
  const [activeTab, setActiveTab] = useState("1");
  const { id } = useParams();
  const navigate = useNavigate()
  const textRef = useRef(null);
  const [textheight, setTextHeight] = useState();
  console.log(id);
  const [data, setData] = useState();

  const fetchDatabyId = async (id) => {
    const res = await NewsService.getDetail(id);
    setData(res);
  };

  useEffect(() => {
    fetchDatabyId(id);
  }, [id]);
  console.log(data);

  const breadcrumbItems = [{ title: "Back to List", link: "/news" }];
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="News Detail"
            pageTitle="News"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col>
              <Card className="mt-n4 mx-n4 border">
                <div
                  className="bg-warning-subtle d-flex "
                  style={{ height: "150px" }}
                >
                  <CardBody className="pb-0 px-4">
                    <Row className="mb-3">
                      <div className="col-md">
                        <Row className="align-items-center g-3">
                          <div className="col-md-auto">
                            <div className="avatar-md">
                              <div className="avatar-title bg-white rounded-circle">
                                <img src={slack} alt="" className="avatar-xs" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md  ">
                            <div className="position-absolute  me-3" style={{ right: "0",zIndex: 100 }}>

                <button
                        type="button"
                        className="btn btn-sm btn-primary d-flex align-items-center gap-1"
                        onClick={() => navigate(`/news/update/${id}`)}
                        style={{ fontSize: "0.875rem" }}
                      >
                        <Edit3 size={14} />
                        Update 
                      </button>
                </div>
                            <h5 className="fw-bold mb-4 w-75">{data?.title}</h5>
                            <div className="hstack gap-3 flex-wrap">
                              <div className="vr"></div>
                              <div>
                                Published Date :{" "}
                                <span className="fw-medium">
                                  {formatDateTime(data?.publishedAt)}
                                </span>
                              </div>

                              <div className="vr"></div>
                              <div className="badge bg-success fs-12">
                                {data?.isActive ? "Active" : "Inactive"}
                              </div>
                            </div>
                          </div>
                        </Row>
                      </div>
                    </Row>
                  </CardBody>
                </div>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col sm={12} lg={8}>
              <Card className="h-100">
                <CardBody>
                  <div className="text-muted">
                    <h5 className="mb-3 fw-bold text-uppercase">
                      News Content
                    </h5>
                    <p>{data?.fullText}</p>
                    <h5 className="mb-3 fw-bold text-uppercase">
                      News short description
                    </h5>
                    <div />
                    <div
                      className="text-muted content-preview "
                      dangerouslySetInnerHTML={{
                        __html: data?.shortDescription,
                      }}
                    />
                  </div>
                  <div className="pt-3 border-top border-top-dashed mt-4">
                    <Row>
                      <Col lg={12} sm={12} className="mb-2">
                        <div className="d-flex justify-content-between align-content-center align-items-center">
                          <p className="mb-2 text-uppercase fw-medium fs-14">
                            Published Date :
                          </p>
                          <h5 className="fs-15 mb-0">
                            {" "}
                            {formatDateTime(data?.publishedAt)}
                          </h5>
                        </div>
                      </Col>
                      <Col lg={12} sm={12} className="mb-2">
                        <div className="d-flex justify-content-between align-content-center align-items-center">
                          <p className=" text-uppercase fw-medium ">Status :</p>
                          <div className="badge bg-success fs-12">
                            {data?.isActive ? "Active" : "Inactive"}
                          </div>
                        </div>
                      </Col>
                      <Col lg={12} sm={12} className="mb-2">
                        <p className="mb-2 text-uppercase fw-medium fs-14">
                          Source Link :
                        </p>
                        <a
                          href={
                            data?.sourceLink?.startsWith("http")
                              ? data.sourceLink
                              : `https://${data?.sourceLink}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <h5 className="fs-15 mb-0">{data?.sourceLink}</h5>
                        </a>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4} sm={12}>
              <img
                src={`${imageBaseApi}${data?.featuredMedia?.url}`}
                style={{
                  maxHeight: "100%",
                  maxWidth: "100%",
                  objectFit: "cover",
                }}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BlogDetail;
